var _a;
import React from 'react';
import styled from 'styled-components';
import { RequiredStar } from '../../styled';
const icon = (_a = require('./icon_sender.svg')) === null || _a === void 0 ? void 0 : _a.default;
export const SectionHeaderWrapper = styled.div `
  background-color: ${(props) => props.theme.sectionHeaderBg};
  color: ${(props) => props.theme.fontColor};
  vertical-align: middle;
  height: ${(props) => (props.infoText ? 'auto' : '32px')};
  display: flex;
  flex-direction: ${(props) => (props.infoText ? 'column' : 'row')};
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  align-items: center;
  .head {
    margin: 8px 0;
    line-height: 18px;
    font-size: ${(props) => props.theme.fontSmall};
    font-weight: ${(props) => props.theme.bold};
  }
  .sub-head {
    font-size: ${(props) => props.theme.fontXXSmall};
    margin: 8px 0;
    line-height: 14px;
  }
  .info-box {
    color: ${(props) => props.theme.fontColor};
    line-height: 18px;
    font-size: ${(props) => props.theme.fontSmall};
  }
  .required-star {
    margin-right: 5px;
  }
  img {
    margin-right: 5px;
  }
`;
const SectionHeader = ({ text, subText, color, infoText, senderIcon, required, }) => {
    return (React.createElement(SectionHeaderWrapper, { infoText: infoText },
        required && React.createElement(RequiredStar, { className: "required-star" }),
        senderIcon && React.createElement("img", { src: icon, alt: "icon" }),
        React.createElement("span", { className: "head" }, text),
        subText ? (React.createElement("span", { style: color ? { color } : {}, className: "sub-head" }, subText)) : (''),
        infoText && React.createElement("p", { className: "info-box" }, infoText)));
};
SectionHeader.defaultProps = {
    required: false,
    senderIcon: false,
};
export default SectionHeader;
